//Sass 컴파일
import '../../sass/sub/_setting.scss';



export const campaignActions = {
	init:function() {
	},
	naverCampaign:function(thisEl) {
		var $this = $(thisEl);
		var eventOn = 'active';
		var activeCheck = $(this).hasClass(eventOn);
		if(activeCheck === false) {
			$('.on_campaign ul li a').removeClass(eventOn);
			$this.addClass(eventOn);
		}
	}
}



//셋팅 페이지 단독 액션
window.campaignActions = campaignActions;



// WEBPACK FOOTER //
// ./js/sub/setting.js